const actionTypeIdentifier = 'F910B160-11D0-4C88-8D6E-SDAFASDFERW234234'; // to be updated

//location form actions
export const setCountryOptions = `SET-NEW-QUOTATION-COUNTRY-OPTIONS-${actionTypeIdentifier}`;
//subscription form actions
export const setVendorDetails = `SET-NEW-QUOTATION-FORM-VENDOR-DETAILS-${actionTypeIdentifier}`;
export const setRequestTypeOptions = `SET-NEW-QUOTATION-FORM-REQUEST-TYPE-OPTIONS-${actionTypeIdentifier}`;
export const setVendorOptions = `SET-NEW-QUOTATION-FORM-VENDOR-OPTIONS-${actionTypeIdentifier}`;
export const setCircuitTypeOptions = `SET-NEW-QUOTATION-FORM-CIRCUIT-TYPE-OPTIONS-${actionTypeIdentifier}`;
export const setContractTermOptions = `SET-NEW-QUOTATION-FORM-CONTRACT-TERM-OPTIONS-${actionTypeIdentifier}`;
export const setBandwidthOptions = `SET-NEW-QUOTATION-FORM-BANDWIDTH-OPTIONS-${actionTypeIdentifier}`;
export const setVendorSelected = `SET-NEW-QUOTATION-FORM-VENDOR-SELECTED-${actionTypeIdentifier}`;
export const setCircuitTypeSelected = `SET-NEW-QUOTATION-FORM-CIRCUIT-TYPE-SELECTED-${actionTypeIdentifier}`;
export const setContractTermSelected = `SET-NEW-QUOTATION-FORM-CONTRACT-TERM-SELECTED-${actionTypeIdentifier}`;
export const setBandwidthSelected = `SET-NEW-QUOTATION-FORM-BANDWIDTH-SELECTED-${actionTypeIdentifier}`;
export const setOtherBandwidthField = `SET-NEW-QUOTATION-FORM-OTHER-BANDWIDTH-FIELD-${actionTypeIdentifier}`;
//business form actions
export const setPurposeOfUseOptions = `SET-NEW-QUOTATION-PURPOSE-OF-USE-OPTIONS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-NEW-QUOTATION-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const resetQuotationRequest = `RESET-NEW-QUOTATION-REQUEST-${actionTypeIdentifier}`;

export const quotationLocationModelA = {
    countryCode: ''
    , country: ''
    , quotationAddress: ''
    , quotationAddress2: ''
}

export const quotationSubscriptionModelA = {
    quotationRequestTypeId: 0
    , quotationRequestTypeName: ''
    , quotationVendorListIds: []
    , quotationCircuitTypeIds: []
    , quotationContractTermIds: []
    , quotationBandwidthIds: []
    , quotationBandwidthOther: ''
}

export const quotationBusinessModelA = {
    purposeOfUseId: 0
    , purposeOfUse: ''
    , businessJustification: ''
    , additionalInformation: ''
}